// extracted by mini-css-extract-plugin
export var checkboxControl = "styles-module--checkboxControl--8befc";
export var checkboxControlIcon = "styles-module--checkboxControlIcon--5df07";
export var checkboxControlWrapper = "styles-module--checkboxControlWrapper--04dc2";
export var disabled = "styles-module--disabled--d8a92";
export var draw = "styles-module--draw--7cd56";
export var large = "styles-module--large--d525e";
export var medium = "styles-module--medium--e16a7";